import React, { useState } from 'react';
import { Mail, Facebook, Instagram, Loader2 } from 'lucide-react';
import { SOCIAL_LINKS } from '../data/siteContent';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ICONS = { facebook: Facebook, instagram: Instagram };

const ConnectStrip = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/api/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error();
      toast.success("Welcome to the Bow Tie Club! You'll hear about new arrivals first.");
      setEmail('');
    } catch {
      toast.error('Could not subscribe right now. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="connect" data-testid="connect-section" className="py-14 bg-[#7B1E2B]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
        <div className="text-center md:text-left">
          <h3 className="text-2xl font-serif font-bold text-white mb-2">Join the Bow Tie Club</h3>
          <p className="text-white/80 text-sm mb-5">Be the first to see new arrivals and exclusive looks.</p>
          <form onSubmit={handleSubscribe} className="flex gap-2 max-w-md mx-auto md:mx-0">
            <input
              data-testid="newsletter-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              className="flex-1 px-4 py-3 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#E6D7B3]"
            />
            <button
              type="submit"
              data-testid="newsletter-subscribe-button"
              disabled={submitting}
              className="px-5 py-3 bg-[#001B2A] text-white rounded-md font-semibold text-sm hover:bg-[#E6D7B3] hover:text-[#001B2A] transition-colors disabled:opacity-60 flex items-center gap-2"
            >
              {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />}
              JOIN
            </button>
          </form>
        </div>
        <div className="text-center md:text-right">
          <h3 className="text-2xl font-serif font-bold text-white mb-2">Follow The Bow Tie Guy</h3>
          <p className="text-white/80 text-sm mb-5">Fresh looks, new drops, and style inspiration.</p>
          <div className="flex gap-4 justify-center md:justify-end">
            {SOCIAL_LINKS.map(({ id, label, handle, url }) => {
              const Icon = ICONS[id] || Instagram;
              return (
                <a
                  key={id}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-${id}-link`}
                  className="flex items-center gap-2 px-5 py-3 bg-white/10 border border-white/20 rounded-md text-white text-sm hover:bg-white hover:text-[#7B1E2B] transition-colors"
                >
                  <Icon className="h-5 w-5" />
                  <span className="hidden sm:inline">{handle}</span>
                  <span className="sm:hidden">{label}</span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConnectStrip;
